(function () {
  if (window.parent === window && !window.location.pathname.startsWith("/embed")) return;

  let authErrorSent = false;

  function authTarget() {
    let path = window.location.pathname;
    let search = window.location.search;
    const onLogin =
      path === "/login" ||
      path === "/login/embedded" ||
      path.endsWith("/login") ||
      path.endsWith("/login/embedded");

    if (!onLogin) return { path, search };

    const params = new URLSearchParams(search);
    const redirect = params.get("redirect_url") || params.get("redirect") || "";
    if (!redirect.startsWith("/")) return { path: "", search: "" };

    const question = redirect.indexOf("?");
    return {
      path: question >= 0 ? redirect.slice(0, question) : redirect,
      search: question >= 0 ? redirect.slice(question) : "",
    };
  }

  function notifyAuthError() {
    if (authErrorSent) return;
    authErrorSent = true;

    const target = authTarget();
    window.parent.postMessage(
      {
        source: "managing-embed",
        type: "auth-error",
        path: target.path,
        search: target.search,
      },
      "*"
    );
  }

  const pathname = window.location.pathname;
  if (pathname === "/login" || pathname.endsWith("/login")) {
    notifyAuthError();
    return;
  }

  $(document).ajaxError(function (_event, xhr) {
    if (xhr && xhr.status === 401) notifyAuthError();
  });

  if (window.Ingtech && Ingtech.page && typeof Ingtech.page.on === "function") {
    Ingtech.page.on("user.unauthenticated", notifyAuthError);
  }

  let ignoreNavigateUntil = 0;

  function currentUrl() {
    return window.location.pathname + window.location.search;
  }

  function notifyParent() {
    window.parent.postMessage(
      {
        source: "managing-embed",
        type: "navigation",
        path: window.location.pathname,
        search: window.location.search,
      },
      "*"
    );
    // Parent may echo a navigate while syncing the address bar — ignore briefly.
    ignoreNavigateUntil = Date.now() + 500;
  }

  function patchHistory(methodName) {
    const original = history[methodName];
    history[methodName] = function (state, title, url = null) {
      // if current url is /embed and new url is not /embed, add /embed to the new url
      if (currentUrl().startsWith("/embed") && !url?.startsWith("/embed")) {
        url = "/embed" + url;
      }

      const result = original.apply(this, [state, title, url]);
      notifyParent();
      return result;
    };
  }

  patchHistory("pushState");
  patchHistory("replaceState");
  window.addEventListener("popstate", notifyParent);

  window.addEventListener("message", function (event) {
    // Parent liveness check: answering proves this page's scripts are running.
    if (event.data && event.data.type === "ping" && event.source) {
      event.source.postMessage({ source: "managing-embed", type: "pong" }, event.origin);
      return;
    }

    if (
      !event.data ||
      // event.data.source !== Ingtech.PARENT_SOURCE ||
      event.data.type !== "navigate"
    )
      return;
    if (typeof event.data.path !== "string") return;
    if (Date.now() < ignoreNavigateUntil) return;

    const search = typeof event.data.search === "string" ? event.data.search : "";
    const next = event.data.path + search;
    if (currentUrl() === next) return;
    window.location.assign(next);
  });

  notifyParent();
})();
